// extracted by mini-css-extract-plugin
export var closeButton = "_t-5";
export var container = "_t-0";
export var contentContainer = "_t-1";
export var desktop = "_t-2";
export var fullModalImage = "_t-6";
export var mobile = "_t-3";
export var withImage = "_t-4";